// extracted by mini-css-extract-plugin
export default {"root":"UaE57","invalid":"LP2m0","error-text":"WL3Jz"};